import { render, staticRenderFns } from "./examination-reply.vue?vue&type=template&id=0d97df87&scoped=true&"
import script from "./examination-reply.vue?vue&type=script&lang=js&"
export * from "./examination-reply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d97df87",
  null
  
)

export default component.exports